// src/features/auth/components/LoginPage.jsx
import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import HTopbar from '../../hooks/HomeTopBar';
import { loginApi } from '@/lib/api/Auth';

import { redirectUser } from '@/lib/api/Redirect';

import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // start loading
    const start = Date.now(); // track start time

    try {
      await loginApi({ email, password });
      const user = await redirectUser();

      if (user.is_admin) navigate('/admin');
      else if (user.account_type === 'sport_participant') navigate('/participant');
      else if (user.account_type === 'sport_organizer') navigate('/organizer');

    } catch (error) {
      if (error.message === "Invalid credentials") {
        alert('Login failed: ' + error.message);
      } else if (error.request) {
        alert('Login failed: No response from server');
      } else {
        console.log('Login failed: ' + error.message);
      }
    } finally {
      const elapsed = Date.now() - start;
      const remaining = 2000 - elapsed; // ensure at least 2 seconds
      if (remaining > 0) {
        setTimeout(() => setLoading(false), remaining);
      } else {
        setLoading(false);
      }
    }
  };



  return (
    <div className="vh-100 vw-100 overflow-hidden position-relative" style={{
      backgroundColor: '#FF945B', // sets the entire background color
    }}>
      {/* Fixed Top Bar */}
      <HTopbar />

      {/* Mobile background image */}
      <div
        className="d-block d-md-none position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: 'url(/images/auth/login.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
        }}
      />

      {/* Main Content */}
      <div
        className="d-flex flex-column flex-md-row position-relative justify-content-center align-items-center"
        style={{ height: 'calc(100vh - 60px)', marginTop: '60px', zIndex: 1, gap: '2rem' }}
      >
        {/* Left Side - Image (desktop) */}
        <div className="d-none d-md-block" style={{ width: '48%', minWidth: '300px', height: '95%' }}>
          <img
            src="/images/auth/login.jpg"
            alt="Login visual"
            className="img-fluid w-100 h-100"
            style={{ objectFit: 'cover', borderRadius: '0.5rem' }}
          />
        </div>

        {/* Right Side - Floating Login Card */}
        <div className="d-none d-md-flex justify-content-center align-items-center" style={{ width: '48%', minWidth: '300px', height: '95%' }}>
          <div
            className="rounded shadow text-center w-100 h-100 d-flex flex-column justify-content-center"
            style={{
              padding: '30px',
              backgroundColor: '#681010cb',
            }}
          >
            <h1
              className="mb-3"
              style={{
                fontSize: '100px',       // 50px explicitly
                fontWeight: 900,        // thicker than fw-bold
                lineHeight: 1.1,
                color: '#FFFFFF'
              }}
            >
              MATCH<br />UP
            </h1>

            <p
              className="mb-2"
              style={{
                fontSize: '2.5rem',       // bigger than the second
                fontWeight: 700,          // make it stand out
                color: '#FFFFFF',
                letterSpacing: '2px'      // optional, stretches the text
              }}
            >
              Welcome to MatchUp
            </p>
            <p
              className="fs-5 mb-4"
              style={{ color: '#FFFFFF' }}
            >
              Your Game, Your People, Your Match.
            </p>


            <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center" style={{ width: '100%' }}>
              {/* Email Field */}
              <div className="position-relative mb-3" style={{ width: '70%' }}>
                <i
                  className="bi bi-envelope text-dark"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '1rem',
                    pointerEvents: 'none',
                  }}
                ></i>
                {/* Vertical bar */}
                <span
                  style={{
                    position: 'absolute',
                    left: '36px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '1px',
                    backgroundColor: '#ced4da',
                    pointerEvents: 'none',
                  }}
                ></span>
                <input
                  type="email"
                  className="form-control ps-5"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    borderRadius: '0.75rem',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    height: '45px',
                    paddingLeft: '45px', // space for icon + bar
                  }}
                />
              </div>

              {/* Password Field */}
              <div className="position-relative mb-3" style={{ width: '70%' }}>
                <i
                  className="bi bi-lock text-dark"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '1rem',
                    pointerEvents: 'none',
                  }}
                ></i>
                {/* Vertical bar */}
                <span
                  style={{
                    position: 'absolute',
                    left: '36px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '1px',
                    backgroundColor: '#ced4da',
                    pointerEvents: 'none',
                  }}
                ></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control ps-5 pe-5"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    borderRadius: '0.75rem',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    height: '45px',
                    paddingLeft: '45px', // space for icon + bar
                    paddingRight: '2.5rem', // space for eye button
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                  }}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} text-dark`}></i>
                </button>
              </div>

              {/* Forgot Password */}
              <div className="text-end mb-3" style={{ width: '90%', maxWidth: '400px' }}>
                <Link
                  to="/forgot"
                  className="small text-decoration-none"
                  style={{ color: '#FFFFFF', fontWeight: '500' }}
                >
                  Forgot Password?
                </Link>
              </div>

              {/* Submit Button */}
              <div className="d-grid mb-3" style={{ width: '70%' }}>
                <button type="submit" className="btn btn-dark py-2 fw-bold" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Logging in...
                    </>
                  ) : (
                    'Log in'
                  )}
                </button>
              </div>


              {/* Register Link */}
              <p
                className="small text-center"
                style={{ width: '90%', maxWidth: '400px', color: '#FFFFFF' }}
              >
                Don't have an account?{' '}
                <Link
                  to="/register"
                  className="text-decoration-none"
                  style={{ color: '#FFFFFF', fontWeight: '500' }}
                >
                  Register
                </Link>
              </p>
            </form>


          </div>
        </div>

        {/* Mobile form */}
        <div className="d-block d-md-none d-flex justify-content-center align-items-center w-100 h-48">
          <div
            className="rounded shadow text-center w-100"
            style={{
              maxWidth: '450px',
              padding: '30px',
              backgroundColor: '#990000cb',
            }}
          >
            <h1 className="fw-bold mb-3" style={{ fontSize: '3rem', lineHeight: '1.1', color: '#FFFFFF' }}>
              MATCH<br />UP
            </h1>
            <p className="fs-4 mb-2" style={{ color: '#FFFFFF' }}>Welcome to MatchUp</p>
            <p className="fs-5 mb-4" style={{ color: '#FFFFFF' }}>Your Game, Your People, Your Match.</p>


            <form
              onSubmit={handleSubmit}
              className="d-flex flex-column align-items-center"
              style={{ width: '100%' }}
            >
              {/* Email Field */}
              <div
                className="position-relative mb-3"
                style={{
                  width: '90%', // wider on mobile
                  maxWidth: '400px',
                }}
              >
                <i
                  className="bi bi-envelope text-dark"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '1rem',
                    pointerEvents: 'none',
                  }}
                ></i>
                <span
                  style={{
                    position: 'absolute',
                    left: '36px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '1px',
                    backgroundColor: '#ced4da',
                    pointerEvents: 'none',
                  }}
                ></span>
                <input
                  type="email"
                  className="form-control ps-5"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    borderRadius: '0.75rem',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    height: '45px',
                    paddingLeft: '45px',
                  }}
                />
              </div>

              {/* Password Field */}
              <div
                className="position-relative mb-3"
                style={{
                  width: '90%',
                  maxWidth: '400px',
                }}
              >
                <i
                  className="bi bi-lock text-dark"
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '1rem',
                    pointerEvents: 'none',
                  }}
                ></i>
                <span
                  style={{
                    position: 'absolute',
                    left: '36px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    height: '60%',
                    width: '1px',
                    backgroundColor: '#ced4da',
                    pointerEvents: 'none',
                  }}
                ></span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control ps-5 pe-5"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    borderRadius: '0.75rem',
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    height: '45px',
                    paddingLeft: '45px',
                    paddingRight: '2.5rem',
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                  }}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} text-dark`}></i>
                </button>
              </div>

              {/* Forgot Password */}
              <div className="text-end mb-3" style={{ width: '90%', maxWidth: '400px' }}>
                <Link
                  to="/forgot"
                  className="small text-decoration-none"
                  style={{ color: '#FFFFFF', fontWeight: '500' }}
                >
                  Forgot Password?
                </Link>
              </div>

              {/* Submit Button */}
              <div className="d-grid mb-3" style={{ width: '90%', maxWidth: '400px' }}>
                <button type="submit" className="btn btn-dark py-2 fw-bold" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Logging in...
                    </>
                  ) : (
                    'Log in'
                  )}
                </button>
              </div>

              {/* Register Link */}
              <p
                className="small text-center"
                style={{ width: '90%', maxWidth: '400px', color: '#FFFFFF' }}
              >
                Don't have an account?{' '}
                <Link
                  to="/register"
                  className="text-decoration-none"
                  style={{ color: '#FFFFFF', fontWeight: '500' }}
                >
                  Register
                </Link>
              </p>


            </form>

          </div>
        </div>

      </div>
    </div>
  );
};

export default LoginPage;
